//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Join.js";
import "../no/TaggedObject.js";
let d=[[[0,"AttributeDataSource",1,0],[0,"ClassificationClassId",1,0],[0,"ClassificationInstanceId",1,0],[0,"FamilyInstance",1,0],[0,"Name",1,0],[0,"Orientation",1,0],[0,"Path",1,0],[0,"Specification",1,0],[0,"SpecificationDescriptiveName",1,0],[0,"Thickness",1,0],[0,"ThreadPitch",1,0],[0,"ThreadedLength",1,0],[0,"Type",1,0]],[],[]];
SPLM.Join.PointJoinHardware = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Join.PointJoinHardware";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Join.PointJoinHardware.AttributeDataSourceType = Object.freeze({
    "Undefined" : "Undefined", "XmlDatabase" : "XmlDatabase", "ReuseLibraryExcel" : "ReuseLibraryExcel", "TeamcenterClassification" : "TeamcenterClassification", "XmlDatabaseSpecification" : "XmlDatabaseSpecification", "ReuseLibrarySpecification" : "ReuseLibrarySpecification"});

export default SPLM;